import { ApolloClient, InMemoryCache } from '@apollo/client';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat } from 'apollo-link';

const serverUrl = process.env.REACT_APP_APOLLO_SERVER_URI;
const httpLink = new HttpLink({
  // uri: "https://test-apollo.api.bond.ai/"
  // uri: process.env.APOLLO_SERVER_URI
  uri: serverUrl,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = sessionStorage.getItem('token');

  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '', // This will be dynamically updated
    },
  });
  return forward(operation);
});

const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
});

export { client, httpLink };
